import React from "react";
import { RealCar } from "./RealCar";

export const CarRow = () => (
  <div className="absolute inset-0 pointer-events-none overflow-hidden">
    <RealCar
      sources={["/cars/petronas.gif"]}
      direction="rtl"
      startY="30vh"
      width={420}
      duration={5.2}
      delay={0.2}
      showDebug
    />
    <RealCar
      sources={[ "/cars/ferrari.gif"]}
      direction="ltl"
      startY="40vh"
      width={440}
      duration={5.6}
      delay={0.6}
      tint="#dc2626"
      showDebug
    />
  </div>
);
